





















































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Account, MarketplaceSpend } from '@/Account'
import { Auction } from '@/Auction'
import { Feedback, roleType } from '@/Feedback'
import * as utils from '@/utils';
import * as utils_time from '@/utils_time';
import * as utils_topshot from '@/utils_topshot';

@Component({
  name: 'AccountUsernameComponent',
  components: { }
})
export default class AccountUsernameComponent extends Vue {
  // prop reactive member variables publically available to the html template
  @Prop()
  public flowAddress: string

  @Prop()
  public username: string

  @Prop()
  public usernameLink: string  

  @Prop()
  public collectorScore: number

  @Prop()
  public dropBonus: number

  @Prop()
  public dropBonusWNBA: number

  @Prop({ default: null })
  public marketplaceSpend: MarketplaceSpend  

  @Prop()
  public auctionScore: number  

  @Prop()
  public feedbackRating: number  

  @Prop()
  public auctionRole: roleType

  @Prop()
  public popoverPlacement: string

  @Prop()
  public uniqueId: string  

  @Prop({ default: true })
  public showAuctionStuffEvenIfZero: boolean

  @Prop()
  public isSignedInUser: boolean

  // may not always have this, but when we do, it can be useful
  @Prop()
  public account: Account

  // public reactive member variables available to the html template

  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading }
  public get getPopoverPlacement(): string { return this.popoverPlacement || 'right' }
  public get getClassNameBasedOnRole(): string { 
    if (!this.auctionRole) return 'noRole'
    if (this.auctionRole === roleType.Seller) return 'sellerUsername'
    if (this.auctionRole === roleType.Buyer) return 'bidderUsername'
   }
  public get collectorScoreForPosting(): number { return Auction.MIN_COLLECTOR_SCORE_TO_POST }
  public get collectorScoreForBidding(): number { return Auction.MIN_COLLECTOR_SCORE_TO_BID}
  public get getNiceMarketPlaceSpend(): string {
    if (this.marketplaceSpend == null || this.marketplaceSpend.spendOnStillOwnedMoments == null) return null
    const value: number = this.marketplaceSpend.spendOnStillOwnedMoments
    const absValue: number = Math.abs(value)
    const negativeSign: string = value < 0 ? '-' : ''
    if (absValue < 10000) return negativeSign + '$' + Math.round(absValue)
    if (absValue < 100000) return negativeSign + '$' + (absValue / 1000).toFixed(1) + 'K'
    if (absValue < 1000000) return negativeSign + '$' + (absValue / 1000).toFixed(0) + 'K'
    return negativeSign + '$' + (absValue / 1000000).toFixed(1) + 'M'
  }
  public get getNiceNetMarketPlaceSpend(): string {
    if (this.marketplaceSpend == null || this.marketplaceSpend.giftBackDec16 == null) return null
    const value: number = this.marketplaceSpend.giftBackDec16.net
    const absValue: number = Math.abs(value)
    const negativeSign: string = value < 0 ? '-' : ''
    if (absValue < 10000) return negativeSign + '$' + Math.round(absValue)
    if (absValue < 100000) return negativeSign + '$' + (absValue / 1000).toFixed(1) + 'K'
    if (absValue < 1000000) return negativeSign + '$' + (absValue / 1000).toFixed(0) + 'K'
    return negativeSign + '$' + (absValue / 1000000).toFixed(1) + 'M'
  }
  public get getNiceYTDNetMarketPlaceSpend(): string {
    if (this.marketplaceSpend == null || this.marketplaceSpend.netJan012023 == null) return null
    const value: number = this.marketplaceSpend.netJan012023.net
    const absValue: number = Math.abs(value)
    const negativeSign: string = value < 0 ? '-' : ''
    if (absValue < 10000) return negativeSign + '$' + Math.round(absValue)
    if (absValue < 100000) return negativeSign + '$' + (absValue / 1000).toFixed(1) + 'K'
    if (absValue < 1000000) return negativeSign + '$' + (absValue / 1000).toFixed(0) + 'K'
    return negativeSign + '$' + (absValue / 1000000).toFixed(1) + 'M'
  }  
  public get niceFeedbackRating(): string { return this.feedbackRating ? this.feedbackRating.toFixed(1) : "0.0" }
  public get getNiceAuctionScore() { return utils_topshot.getNiceAuctionScore(this.auctionScore) }
  public get getNiceCollectorScore() { return utils_topshot.getNiceCollectorScore(this.collectorScore) }

  public get getClassNameBasedOnScore() { return utils_topshot.getClassNameBasedOnScore2(this.collectorScore) }
  public get getClassNameBasedOnAuctionScore() { return utils_topshot.getClassNameBasedOnAuctionScore(this.auctionScore) }
  public get collectorScorePopupTitle(): string { return this.marketplaceSpend != null ? 'Top Shot Score & Marketplace Spend' : 'Top Shot Score' }

  public usernameClicked() {
    if (this.usernameLink) window.open(this.usernameLink, "_blank");    // if caller wants to override
    window.open(Account.getPortfolioLink(this.flowAddress), "_blank");  // go to made portfolio page for the user
    // if (!this.auctionRole) window.open(Account.getPortfolioLink(this.flowAddress), "_blank");
    // else window.open(Account.getAuctionsLink(this.flowAddress), "_blank");
  }
  public feedbackRatingClicked() {
    const url: string = Account.getFeedbackLink(this.flowAddress)
    if (url) window.open(url, "_blank"); 
  }
  public clickedOnLiveTokenAuctions() {
    const url: string = Auction.getAuctionListingsLink()
    if (url) window.open(url, "_blank"); 
  }

  public get showNMS_For_GiftBack(): boolean { return (utils_topshot.getDapperMode()) || (this.isSignedInUser) }


  // private, non-reactive member variables

  // private functions not available directly to HTML template
  private async mounted() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)
  }

  private async beforeDestroy() { if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`) }

}
